import * as React from "react";

const AppContext = React.createContext<any>({});

export default AppContext;
